import { render, staticRenderFns } from "./RegistrationDisclosure.vue?vue&type=template&id=30e4b2c6&scoped=true&"
import script from "./RegistrationDisclosure.vue?vue&type=script&lang=ts&"
export * from "./RegistrationDisclosure.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationDisclosure.vue?vue&type=style&index=0&id=30e4b2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4b2c6",
  null
  
)

export default component.exports